<template>
  <f7-page>
    <f7-navbar title="營業時間設定" back-link="back">
      <f7-nav-right>
        <f7-link @click="uploadBusinessHours(menuVariationProp)">上傳</f7-link>
      </f7-nav-right>
    </f7-navbar>

    <div v-if="isBusinessHourDirty" class="warning">請按上傳完成變更</div>

    <f7-list v-if="menuBusinessHours" no-hairlines-md style="margin: 0px;">
      <business-hour-list-group
        v-for="(weekday, index) in weekdays"
        :menuVariation="menuVariationProp"
        :businessHours="menuBusinessHours[index]"
        :key="`business-hour-list-${index}`"
        :weekday="weekday"
        :weekdayIndex="index"/>
    </f7-list>
  </f7-page>
</template>

<script>
import BusinessHourListGroup from '@/components/BusinessHourListGroup'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      weekdays: ['星期日', '星期ㄧ', '星期二', '星期三', '星期四', '星期五', '星期六']
    }
  },
  created () {
    this.downloadBusinessHours(this.menuVariationProp)
  },
  computed: {
    ...mapState('menuModule', ['businessHours', 'businessHourDirtyStates']),
    ...mapGetters(['storeId']),
    menuBusinessHours () { return this.businessHours[this.menuVariationProp] },
    isBusinessHourDirty () { return this.businessHourDirtyStates[this.menuVariationProp] }
  },
  props: {
    storeIdProp: String,
    menuVariationProp: String
  },
  methods: {
    ...mapActions('menuModule', ['downloadBusinessHours', 'uploadBusinessHours'])
  },
  components: {
    BusinessHourListGroup
  }
}
</script>

<style lang="scss" scoped>
.warning {
  color: #856404;
  background-color: #FFF3CD;
  border: solid 1px #FFEEBA;
  border-radius: 5px;
  width: 90%;
  margin: 20px auto;
  padding: 10px 20px;
  box-shadow: 2px 2px 2px #EEEEEE;
  box-sizing: border-box;
}
</style>
